import { render, staticRenderFns } from "./PersonalGeneration.vue?vue&type=template&id=00b22b4a&scoped=true"
import script from "./PersonalGeneration.vue?vue&type=script&lang=js"
export * from "./PersonalGeneration.vue?vue&type=script&lang=js"
import style0 from "./PersonalGeneration.vue?vue&type=style&index=0&id=00b22b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b22b4a",
  null
  
)

export default component.exports